import { render } from "./ItemsFiveView.vue?vue&type=template&id=5e8b5cc5&scoped=true"
import script from "./ItemsFiveView.vue?vue&type=script&lang=js"
export * from "./ItemsFiveView.vue?vue&type=script&lang=js"

import "./ItemsFiveView.vue?vue&type=style&index=0&id=5e8b5cc5&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8b5cc5"]])

export default __exports__